import { FilterMatchMode } from "primereact/api";

export const supplyColumns = [
    { name: 'Supply id *', key: '1', field: 'id' },
    { name: 'Supply Name *', key: '2', field: 'name' },
    { name: 'Status *', key: '3', field: 'status' },
    { name: 'Revenue *', key: '4', field: 'revenue' },
    { name: 'Fill Rate *', key: '5', field: 'fillRate' },
    { name: 'eRPM *', key: '6', field: 'erpm' },
    { name: 'Impression *', key: '7', field: 'impressions' },
    { name: 'Demand Requests', key: '8', field: 'demandRequests' },
    { name: 'RPMR', key: '9', field: 'rpmr' },
];

export const supplyPartnerColumns = [
    { name: 'Supply Partner  id *', key: '1', field: 'id' },
    { name: 'Supply Partner Name *', key: '2', field: 'supplyPartnerName' },
    { name: 'Revenue *', key: '3', field: 'revenue' },
    { name: 'Fill Rate *', key: '4', field: 'fillRate' },
    { name: 'eRPM *', key: '5', field: 'erpm' },
    { name: 'Impression *', key: '6', field: 'impressions' },
    { name: 'Alignment', key: '7', field: 'alignment' },
    { name: 'RPMR', key: '8', field: 'rpmr' },
];


export const demandColumns = [
    { name: 'Demand id *', key: '1', field: 'id' },
    { name: 'Demand Name *', key: '2', field: 'name' },
    { name: 'Status *', key: '3', field: 'isEnabled' },
    { name: 'Revenue *', key: '4', field: 'revenue' },
    { name: 'Fill Rate *', key: '5', field: 'fillRate' },
    { name: 'eRPM *', key: '6', field: 'erpm' },
    { name: 'Impression *', key: '7', field: 'impressions' },
    { name: 'Demand Requests', key: '8', field: 'demandRequests' },
    { name: 'RPMR', key: '9', field: 'rpmr' },
];


export const demandPartnerColumns = [
    { name: 'Demand Partner id *', key: '1', field: 'id' },
    { name: 'Demand Partner Name *', key: '2', field: 'demandPartnerName' },
    { name: 'Revenue *', key: '3', field: 'revenue' },
    { name: 'Fill Rate *', key: '4', field: 'fillRate' },
    { name: 'eRPM *', key: '5', field: 'erpm' },
    { name: 'Impression *', key: '6', field: 'impressions' },
    { name: 'Demand Requests', key: '7', field: 'demandRequests' },
    { name: 'RPMR', key: '8', field: 'rpmr' },
];


export const routesColumns = [
    { name: 'Routes id *', key: '1', field: 'id' },
    { name: 'Name *', key: '2', field: "name" },
    { name: 'Status *', key: '3', field: "isEnabled" },
    { name: 'QPS *', key: '4', field: "qps" },
    { name: 'Revenue *', key: '5', field: 'revenue' },
    { name: 'Fill Rate *', key: '6', field: "fillRate" },
    { name: 'eRPM *', key: '7', field: 'erpm' },
    { name: 'Impression*', key: '8', field: "impressions" },
    { name: 'RPMR', key: '9', field: 'rpmr' },
]
export const supportColumns = [
    { name: 'Ticket Title *', key: '1' },
    { name: 'Date Created *', key: '2' },
    { name: 'Priority*', key: '3' },
    { name: 'Status *', key: '4' },
    { name: 'Ticket Title *', key: '1' },
    { name: 'Date Created *', key: '2' },
    { name: 'Priority*', key: '3' },
    { name: 'Status *', key: '4' },
]

export const settingUsersColumns = [
    { name: 'Full Name ', key: '1', field: "fullName" },
    { name: 'Email', key: '2', field: "email" },
    { name: 'Role', key: '3', field: "role" },
    { name: 'Designation', key: '4', field: "designation" },
    { name: 'Status *', key: '5', field: "status" },
]

export const time = [
    { name: '1:00', key: '1' },
    { name: '2:00', key: '2' },
    { name: '3:00', key: '3' },
    { name: '4:00', key: '4' },
    { name: '5:00', key: '5' },
    { name: '6:00', key: '6' },
    { name: '7:00', key: '7' },
    { name: '8:00', key: '8' },
    { name: '9:00', key: '9' },
    { name: '10:00', key: '10' },
    { name: '11:00', key: '11' },
];


export const filterOptions = [
    { label: 'Equals', value: FilterMatchMode.EQUALS },
    { label: 'Not equals', value: FilterMatchMode.NOT_EQUALS },
    { label: 'Less Than', value: FilterMatchMode.LESS_THAN },
    { label: 'Less Than or equal to', value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
    { label: 'Greater Than', value: FilterMatchMode.GREATER_THAN },
    { label: 'Greater than or equal to', value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
    { label: 'Between', value: FilterMatchMode.BETWEEN },
];
